
import RelationToOneField from '@/shared/fields/relation-to-one-field';
import {ComplainTypeService} from '@/modules/complain-type/complain-type-service';

export class ComplainTypeField {
    static relationToOne(name, label, rules, filterParams, children, options) {
        return new RelationToOneField(
            name,
            label,
            ComplainTypeService.listAutocomplete,
            (record) => {
                if (!record) {
                    return '';
                }

                return {
                    value: record.id,
                    text: record.name,
                };
            },
            rules,
            filterParams,
            children,
            options,
        );
    }
}
